<template>
  <v-container>
    <v-flex xs12 lg8 offset-lg2 white--text>
      <v-flex pb-3 xs12 text-xs-center >
        <h3 class="display-1">Heute, {{ today.day | getDate }} :</h3>
      </v-flex>
      <v-layout pt-3 v-if="today.open" row>
        <!-- kitchen -->
        <v-flex xs3 md3 white--text text-xs-left text-md-center>
          <v-flex lime--text>
            <h6 class="headline">Küche</h6>
          </v-flex>
          <v-flex order-xs2>
            <h5 class="headline">{{ today.kitchen }}</h5>
          </v-flex>
        </v-flex>
  
        <!-- event meal -->
        <v-flex xs6 md6 text-xs-center style="overflow-x: auto; overflow-y:hidden" >
          <v-layout column>
            <v-flex  blue--text  >
              <h4 class="display-2">{{ today.meal }}</h4>
            </v-flex>
            <v-flex pt-3 v-if="today.veg">
              <svg width="26pt" height="27pt" viewBox="0 0 26 27" version="1.1">
                <g id="surface1">
                  <path style=" stroke:none;fill-rule:nonzero;fill:rgb(0.392157%,49.803922%,0%);fill-opacity:1;" d="M 24.394531 0.523438 C 23.78125 0.679688 22.488281 0.960938 21.527344 1.148438 C 19.070312 1.617188 18.683594 1.757812 17.589844 2.546875 C 16.035156 3.671875 14.949219 5.847656 14.957031 7.824219 C 14.964844 8.574219 15.078125 9.113281 15.210938 8.96875 C 15.242188 8.933594 15.347656 8.71875 15.4375 8.492188 C 15.90625 7.398438 17.257812 5.730469 18.414062 4.828125 C 19.003906 4.367188 20.1875 3.910156 20.1875 4.148438 C 20.1875 4.230469 19.78125 4.722656 19.300781 5.214844 C 18.851562 5.683594 18.695312 5.878906 17.847656 7.078125 C 16.96875 8.335938 15.820312 10.585938 15.050781 12.589844 C 14.300781 14.535156 13.75 16.085938 13.382812 17.246094 C 12.761719 19.238281 12.203125 20.808594 12.105469 20.839844 C 11.984375 20.882812 11.644531 19.816406 10.941406 17.171875 C 9.847656 13.03125 9.382812 11.609375 8.265625 9.015625 C 7.5 7.25 6.492188 5.832031 4.441406 3.664062 C 3.320312 2.464844 1.71875 1.320312 0.757812 1.003906 C 0.128906 0.796875 0.078125 0.902344 0.550781 1.414062 C 2.785156 3.867188 4.074219 5.683594 5.445312 8.269531 C 6.597656 10.46875 7.394531 12.652344 8.839844 17.65625 C 9.207031 18.9375 10.019531 22.203125 10.277344 23.46875 C 10.566406 24.875 10.890625 26.253906 10.972656 26.472656 C 11.003906 26.539062 11.117188 26.628906 11.234375 26.65625 C 11.492188 26.722656 12.746094 26.722656 13.015625 26.65625 C 13.414062 26.546875 13.488281 26.238281 14.039062 22.722656 C 14.40625 20.347656 14.71875 18.925781 15.347656 16.800781 C 16.410156 13.179688 17.542969 10.527344 18.230469 10.09375 C 18.328125 10.035156 18.820312 9.917969 19.332031 9.835938 C 21.320312 9.515625 22.917969 8.65625 24.050781 7.292969 C 24.808594 6.386719 25.007812 5.714844 25.195312 3.480469 C 25.296875 2.292969 25.359375 1.960938 25.585938 1.25 C 25.730469 0.789062 25.832031 0.371094 25.816406 0.320312 C 25.761719 0.1875 25.640625 0.199219 24.394531 0.523438 Z M 24.394531 0.523438 "/>
                </g>
              </svg>
            </v-flex>
  
            <v-flex pt-3 lime--text>
              <h5 class="title">{{ today.event }}</h5>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- bar -->
        <v-flex xs3 md3 white--text text-xs-right text-md-center>
          <v-flex lime--text>
            <h6 class="headline">Theke</h6>
          </v-flex>
          <v-flex>
            <h5 class="headline">{{ today.bar }}</h5>
          </v-flex>
        </v-flex>
      </v-layout>
      <v-flex display-2 v-else pb-3 xs12 text-xs-center text--darken-2 red--text>
        Geschlossen
      </v-flex>
  
    </v-flex>
    <!-- INFO -->
    <v-container pt-5 v-if="today.open">
      <v-flex xs12 text-xs-center class="white--text title">
        Geöffnet ab 19 Uhr
      </v-flex>
      <v-flex pb-4 pt-2 xs12 text-xs-center text--darken-2 red--text headline font-weight-regular>
        Nur für Bewohner der Studentenstadt Freimann
      </v-flex>
    </v-container>
  </v-container>
</template>

<script>
  export default {
    name: 'Today',
    props: {
      today: ''
    },
    filters: {
      getDate: (date) => {
        var options = {
          day: 'numeric',
          month: 'long'
        }
        return new Date(date).toLocaleDateString('de-DE', options)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
